module.exports = __webpack_public_path__ + "img/d820eb22fd4c9203d3c9cc8ea3391677.399593c0.png";